export default function removeBespokePathFromLocale(locale: string, bespokeId: string) {
  return bespokeId ? locale.replace(`${bespokeId}/`, '') : locale
}